export default "/fcbcac1db17390110677298f9d30eeed9c121039/78489dd5fe22b2b724f99f5861a7cee7.svg";